<template>
  <div
    :ref="`node${id}`"
    class="flowchart-node"
    :style="nodeStyle"
    @mousedown="handleMousedown"
    @mouseup="handleMouseup"
    @dblclick="handleDbClick"
    v-bind:class="{
      selected: Number(options.selected) === id,
      gadgets: styleClass.firstClass === 'Gadgets',
      ai: styleClass.firstClass === 'AIModels',
      actions: styleClass.firstClass === 'Actions'
    }"
  >
    <!-- gadgets 的header -->
    <!-- 展示文字 + 按鈕  -->
    <!-- <template v-if="styleClass.firstClass === 'Gadgets'">
      <div class="gadgets-top">
        <span>{{ properties.gadgetsProp.type }}</span>
        <div>
          <span class="setting-icon" @click="clickSettingIcon">
            <img src="@/assets/img_setting.png" draggable="false" />
          </span>
          <span class="eye-icon" @click="clickEyeIcon">
            <img src="@/assets/img_eye_bl.png" draggable="false" />
          </span>
        </div>
      </div>
    </template>-->

    <!-- 第一階段 以comparison的size為準 -->
    <div class="node-container" @click="selectOptionClick">
      <!-- 第一類型 下拉 包含:輸入、展開  -->
      <template
        v-if="
          styleClass.firstClass === 'Logic' ||
            styleClass.firstClass === 'Arithmetic' ||
            styleClass.firstClass === 'Comparison' ||
            styleClass.firstClass === 'Boolean'
        "
      >
        <!-- 輸入部分 -->
        <div class="show-zone" :class="{ round: !showDropDown }">
          <span v-html="selectOperatorSymbol" class="d-inline-block" :style="showZoneStyle"></span>

          <!-- 箭頭部分 -->
          <div class="arrow"></div>
        </div>

        <!-- 展開部分 -->
        <div class="expand-zone" v-show="showDropDown">
          <ul class="list-unstyled mb-0">
            <li
              v-for="(item, key, index) in nodeLeftList"
              class="custom-option"
              :key="index"
              v-html="item"
              @click="selectOperator(key)"
              :style="expandZoneStyle"
            ></li>
          </ul>
        </div>
      </template>

      <!-- 第二類型 變動輸入 或 不能輸入  -->
      <template
        v-else-if="styleClass.firstClass === 'Constant' || styleClass.firstClass === 'Counter'"
      >
        <div class="show-zone-input">
          <div
            class="counter-up"
            v-if="styleClass.firstClass === 'Counter'"
            :class="{ open: styleClass.secondClass === 'CounterUp' }"
          ></div>
          <div
            class="counter-down"
            v-if="styleClass.firstClass === 'Counter'"
            :class="{ open: styleClass.secondClass === 'CounterDown' }"
          ></div>
          <input
            @select="dontSelect"
            ref="dontSelectInput"
            type="number"
            :min="minIntNumber"
            :max="maxIntNumber"
            v-model.number="properties.value"
            :style="showZoneInputStyle"
            :disabled="styleClass.firstClass === 'Counter'"
          />
        </div>
      </template>

      <!-- 第三類型 Gadgets 包含 展示文字 按鈕 跟 多個下拉  -->
      <template v-else-if="styleClass.firstClass === 'Gadgets'">
        <div class="gadgets-top" :style="showZoneGadgetsTopWidth">
          <span>{{ properties.gadgetsProp.type }}</span>
          <div class="img-wrapper">
            <span class="setting-icon" @click="clickSettingIcon">
              <img
                :src="
                  require(`@/assets/icon/DFD/${
                    showZoneActions ? 'gadgets_settings_pressed@3x' : 'gadgets_settings_normal@3x'
                  }.png`)
                "
                draggable="false"
              />
            </span>
            <span class="eye-icon" @click="clickEyeIcon">
              <img
                :src="
                  require(`@/assets/icon/DFD/${
                    showMoreZoneGadgets ? 'gadgets_data_pressed@3x' : 'gadgets_data_normal@3x'
                  }.png`)
                "
                draggable="false"
              />
            </span>
          </div>
        </div>

        <div
          v-for="(item, name, index) in dropDown.Gadgets[styleClass.secondClass]"
          :key="index"
          :class="{
            'show-zone-gadgets': true,
            first: index === 0,
            last: index === Object.keys(dropDown.Gadgets[styleClass.secondClass]).length - 1,
            'open-style':
              showExpandZoneGadgets &&
              gadgetsTargetName === name &&
              nodeLeftList[gadgetsTargetName].length > 0
          }"
          v-show="showZoneGadgets"
          @click="setGadgetsTargetName(name)"
          :style="showZoneGadgetsWidth"
        >
          <template v-if="name === 'ble'">{{ properties.gadgetsProp[name].nickName }}</template>
          <template v-else>{{ properties.gadgetsProp[name] }}</template>

          <!-- 箭頭部分 -->
          <div class="arrow"></div>

          <!-- 展開 -->
          <div
            class="expand-zone-gadgets"
            v-show="
              gadgetsTargetName === name &&
                showExpandZoneGadgets &&
                nodeLeftList[gadgetsTargetName].length > 0
            "
            :style="expandZoneTop"
          >
            <ul class="list-unstyled mb-0">
              <li
                v-for="(item, index) in nodeLeftList[gadgetsTargetName]"
                class="custom-option"
                :key="index"
                @click.stop="selectGadgetsProp(item)"
                :style="showZoneGadgetsWidth"
              >
                {{ name === "ble" ? item.nickName : item }}
              </li>
            </ul>
          </div>
        </div>

        <!-- 更多顯示資訊 -->
        <div class="more-gadgets" v-show="showMoreZoneGadgets">
          {{
            `${properties.value} ${styleClass.secondClass === "Ultrasound" ? "cm" : ""} ${
              styleClass.secondClass === "SoilMoisture" ? "%" : ""
            }`
          }}
        </div>
      </template>

      <!-- 第四類型 Random  Timer-->
      <template
        v-else-if="
          styleClass.firstClass === 'Random' ||
            styleClass.firstClass === 'Timer' ||
            styleClass.firstClass === 'Terminal'
        "
      >
        <div class="img-only-box">
          <img
            v-if="styleClass.firstClass === 'Random'"
            src="@/assets/icon/DFD/random_icon@3x.png"
            :draggable="false"
            alt
          />
          <img
            v-if="styleClass.firstClass === 'Timer'"
            src="@/assets/icon/DFD/timer_icon@3x.png"
            :draggable="false"
            alt
          />
          <img
            v-if="styleClass.firstClass === 'Terminal'"
            src="@/assets/icon/DFD/terminal_icon@3x.png"
            :draggable="false"
            alt
          />
        </div>
      </template>

      <!-- 第五類型 AIModels-->
      <template v-else-if="styleClass.firstClass === 'AIModels'">
        <div class="ai-title" :style="showZoneAITopWidth">
          <span class="text">{{ label }}</span>

          <img
            :src="
              require(`@/assets/icon/DFD/${
                showConfidence ? 'gadgets_data_pressed@3x' : 'gadgets_data_normal@3x'
              }.png`)
            "
            @click="clickAIEyeIcon"
            :draggable="false"
            alt
          />
        </div>
        <hr class="ai-hr" />
        <div
          class="ai-confidence"
          v-for="(item, index) in properties.aiProps"
          :class="{ last: index === properties.aiProps.length - 1 }"
          :key="index"
        >
          <div class="name" :style="showZoneAIWidth">{{ item.name }}</div>
          <div class="progress value" v-show="showConfidence">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :style="{
                width: item.confidence + '%',
                backgroundColor: '#37ccda'
              }"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
            <span style="position:absolute;left:50%;transform:translateX(-50%);color:white"
              >{{ item.confidence }}%</span
            >
          </div>
          <!-- <div class="value" v-show="showConfidence">{{item.confidence}}%</div> -->
        </div>
      </template>

      <!-- 第六類型 Actions-->
      <template v-else-if="styleClass.firstClass === 'Actions'">
        <div class="actions-top" :style="showZoneActionsTopWidth">
          <span>{{ properties.actionsProp.name }}</span>
          <div class="img-wrapper">
            <span class="setting-icon" @click="clickSettingIcon">
              <img
                :src="
                  require(`@/assets/icon/DFD/${
                    showZoneActions ? 'gadgets_settings_pressed@3x' : 'gadgets_settings_normal@3x'
                  }.png`)
                "
                draggable="false"
              />
            </span>
          </div>
        </div>

        <!-- 下拉 -->

        <div
          v-for="(item, name, index) in dropDown.Actions"
          :key="index"
          :class="{
            'show-zone-actions': true,
            first: index === 0,
            last: index === Object.keys(dropDown.Actions).length - 1,
            'open-style':
              showExpandZoneActions &&
              actionsTargetName === name &&
              nodeLeftList[actionsTargetName].length > 0
          }"
          v-show="showZoneActions"
          @click="setActionsTargetName(name)"
          :style="showZoneActionsWidth"
        >
          <template>{{ properties.actionsProp["ble"].nickName }}</template>
          <!-- 箭頭部分 -->
          <div class="arrow"></div>

          <!-- 展開 -->
          <div
            class="expand-zone-actions"
            v-show="
              actionsTargetName === name &&
                showExpandZoneActions &&
                nodeLeftList[actionsTargetName].length > 0
            "
            :style="expandZoneTop"
          >
            <ul class="list-unstyled mb-0">
              <li
                v-for="(item, index) in nodeLeftList[actionsTargetName]"
                class="custom-option"
                :key="index"
                :style="showZoneActionsWidth"
                @click.stop="selectActionsProp(item)"
              >
                {{ name === "ble" ? item.nickName : item }}
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
    <div
      class="node-port node-input toolTips left"
      v-for="(item, index) in properties.inputCount"
      :key="'in' + index"
      :style="portInputStyle[index]"
      @mousedown="inputMouseDown"
      @mouseup="inputMouseUp($event, index, properties.inputCount)"
      :data-tooltip="toolTips[`input${index + 1}`]"
    >
      <div class="val-zone input" v-show="openValZone">
        <template v-if="styleClass.firstClass === 'Logic' || styleClass.firstClass === 'Boolean'">{{
          properties.inputs[`input${index + 1}`] > 0 ? "true" : "false"
        }}</template>
        <template v-else-if="styleClass.firstClass === 'Counter' && (index === 0 || index === 2)">{{
          properties.inputs[`input${index + 1}`] > 0 ? "true" : "false"
        }}</template>
        <template
          v-else-if="
            styleClass.firstClass === 'Timer' ||
              styleClass.firstClass === 'Terminal' ||
              styleClass.firstClass === 'AIModels'
          "
          >{{ properties.inputs[`input${index + 1}`] > 0 ? "true" : "false" }}</template
        >
        <template v-else>{{ properties.inputs[`input${index + 1}`] }}</template>
      </div>
      <div class="node-port-big input"></div>
      <div class="node-port-small input"></div>
    </div>

    <div
      class="node-port node-output toolTips right"
      v-for="(item, index) in properties.outputCount"
      :key="'out' + index"
      @mousedown="outputMouseDown($event, index)"
      :style="portOutputStyle[index]"
      :data-tooltip="toolTips[`output${index + 1}`]"
    >
      <div class="val-zone output" v-show="openValZone">
        <template
          v-if="
            styleClass.firstClass === 'Logic' ||
              styleClass.firstClass === 'Comparison' ||
              styleClass.firstClass === 'Boolean'
          "
          >{{ properties.outputs[`output${index + 1}`] > 0 ? "true" : "false" }}</template
        >
        <template v-else-if="styleClass.firstClass === 'AIModels'">
          {{
            properties.outputs[`output${index + 1}`] === maxAiValue && maxAiValue !== 0 ? "1" : "0"
          }}
        </template>
        <template v-else>{{ properties.outputs[`output${index + 1}`] }}</template>
      </div>
      <div class="node-port-big output"></div>
      <div class="node-port-small output"></div>
    </div>
    <div v-show="isSelected" class="nodeOption">
      <div @click="copyNode(id)">
        <img :src="require(`@/assets/icon/icCopy.png`)" alt="">
      </div>
      <div @click="deleteNode(id)">
        <img :src="require(`@/assets/icon/icDelete.png`)" alt="">
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";

export default {
  name: "FlowchartNode",
  props: {
    id: {
      type: Number,
      default: 1000,
      validator(val) {
        return typeof val === "number";
      }
    },

    x: {
      type: Number,
      default: 0,
      validator(val) {
        return typeof val === "number";
      }
    },
    y: {
      type: Number,
      default: 0,
      validator(val) {
        return typeof val === "number";
      }
    },
    type: {
      type: String,
      default: "Default"
    },
    label: {
      type: String,
      default: "input name"
    },
    styleClass: {
      type: Object
    },
    portStyle: {
      type: Object
    },
    properties: {
      type: Object,
      default() {
        return {
          inputCount: 1
        };
      }
    },
    options: {
      type: Object,
      default() {
        return {
          centerX: 1024,
          scale: 1,
          centerY: 140
        };
      }
    },
    openValZone: {
      type: Boolean
    },
    dropDownTicktok: {
      type: Number
    },
    toolTips: {
      type: Object,
      default() {
        return {};
      }
    },
    selectedNode:{
      type:Array,
      default(){
        return [];
      }
    }
  },
  data() {
    return {
      showDropDown: false,
      maxIntNumber: 32767,
      minIntNumber: -32768,
      // show: {
      //   delete: false
      // },
      dropDown: {
        Logic: {
          AND: "AND",
          OR: "OR",
          NAND: "NAND",
          NOR: "NOR",
          XOR: "XOR",
          NOT: "NOT"
        },
        Arithmetic: {
          Addition: "&#43;",
          Subtraction: "&#8722;",
          Multiplication: "&#215;",
          Division: "&#247;",
          Modulo: "&#37;",
          Power: "&#8743;"
        },
        Comparison: {
          Equality: "&#61;",
          Greater: "&#62;",
          GreaterEqual: "&#8805;",
          Inequality: "&#8800;",
          Less: "&#60;",
          LessEqual: "&#8804;"
        },
        Boolean: {
          True: "True",
          False: "False"
        },
        Gadgets: {
          Infrared: {
            ble: [],
            port: ["Port 1", "Port 2"],
            sensor: ["Sensor 1", "Sensor 2"]
          },
          Ultrasound: {
            ble: [],
            port: ["Port 3"]
          },
          LightSensor: {
            ble: [],
            port: ["Port 1", "Port 2"]
          },
          MicroSwitch: {
            ble: [],
            port: ["Port 1", "Port 2"]
          },
          SoilMoisture: {
            ble: [],
            port: ["Port 1", "Port 2"]
          },
          HallSensor: {
            ble: [],
            port: ["Port 1", "Port 2"]
          },
          VariableBoard: {
            ble: [],
            port: ["Port 4"],
            controlDial: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          JoystickButton: {
            ble: [],
            button: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          JoystickAnalog: {
            ble: [],
            value: ["X", "Y", "Button"]
          }
        },
        Actions: {
          ble: []
        }
      },
      unitWidth: 13,
      baseWidth: 35,
      gadgetsTargetName: "",
      // gadgets 白色區塊
      showZoneGadgets: true,
      // gadgets 打開的下拉
      showExpandZoneGadgets: false,
      // gadgets 特別內容
      showMoreZoneGadgets: true,
      // AIModels 信心欄
      showConfidence: true,
      // Actions 白色區塊
      showZoneActions: true,
      // Actions 打開的下拉
      showExpandZoneActions: false,
      actionsTargetName: "",
      nowX: 0,
      nowY: 0,
      isDragging: false,
      ticktok2: 0
    };
  },
  created() {
    this.register();
  },

  computed: {
    ...mapGetters(["connectedDevicesWithNickname"]),
    isSelected(){
      return this.selectedNode.includes(this.id.toString())
    },
    maxAiValue() {
      const arr = [];
      for (const key in this.properties.outputs) {
        arr.push(this.properties.outputs[key]);
      }

      const maxValue = Math.max(...arr);
      return maxValue;
    },

    nodeStyle() {
      // ticktok 是為了方便 width 跟 style連動 所增加
      const result = {
        top: `${this.options.centerY + this.y}px`, // this.options.centerY + this.y *this.options.scale  + "px"
        left: `${this.options.centerX + this.x}px`, // this.options.centerX + this.x * this.options.scale + "px"
        // transform: `scale(${this.options.scale})`,
        paddingTop: `${
          this.properties.inputCount > 2 ? 7 + (this.properties.inputCount - 2) * 13 : 7
        }px`,
        paddingBottom: `${
          this.properties.inputCount > 2 ? 7 + (this.properties.inputCount - 2) * 13 : 7
        }px`,
        ticktok: this.showZoneWidth,
        ticktok2: this.ticktok2
      };

      if (
        this.styleClass.firstClass === "Gadgets" ||
        this.styleClass.firstClass === "AIModels" ||
        this.styleClass.firstClass === "Actions"
      ) {
        result.paddingTop = "10px";
        result.paddingBottom = "10px";
      }

      return result;
    },

    portInputStyle() {
      // 內部的 port 位置  (相對node)

      const input = [];
      for (let i = 0; i < this.properties.inputCount; i++) {
        const topVal =
          this.styleClass.firstClass === "Gadgets" ||
          this.styleClass.firstClass === "AIModels" ||
          this.styleClass.firstClass === "Actions"
            ? "20.5px"
            : this.properties.inputCount === 1
            ? "50%"
            : `${10 +
                i *
                  (14 +
                    (12 * this.properties.inputCount - 14) / (this.properties.inputCount - 1))}px`;

        input.push({ top: topVal });
      }
      return input;
    },
    portOutputStyle() {
      // 內部的 port 位置  (相對node)
      const output = [];
      const { firstClass } = this.styleClass;
      let topVal = "";
      if (firstClass === "Gadgets" || firstClass === "Actions") {
        topVal = "20.5px";
        output.push({ top: topVal });
      } else if (firstClass === "AIModels") {
        const triggerThisComputed = this.showConfidence;

        const { outputCount } = this.properties;

        if (!triggerThisComputed) {
          for (let i = 0; i < outputCount; i++) {
            topVal = `${11 + 42 + i * 32}px`;

            output.push({ top: topVal });
          }
        } else {
          for (let i = 0; i < outputCount; i++) {
            topVal = `${11 + 42 + i * 62}px`;
            output.push({ top: topVal });
          }
        }
      } else {
        topVal = "50%";
        output.push({ top: topVal });
      }
      return output;
    },
    nodeLeftList() {
      let copy = {};
      switch (this.styleClass.firstClass) {
        case "Gadgets": {
          for (const key in this.properties.gadgetsProp) {
            if (
              key === "sensor" ||
              key === "ble" ||
              key === "port" ||
              key === "controlDial" ||
              key === "button" ||
              key === "value"
            ) {
              const valueShowOnPanel = this.properties.gadgetsProp[key];
              let index = -1;

              copy[key] = [...this.dropDown.Gadgets[this.styleClass.secondClass][key]];

              copy[key].forEach((e, idx) => {
                const value = e;

                if (
                  key === "sensor" ||
                  key === "port" ||
                  key === "controlDial" ||
                  key === "button" ||
                  key === "value"
                ) {
                  index = value === valueShowOnPanel ? idx : index;
                } else if (key === "ble") {
                  index = value.nickName === valueShowOnPanel ? idx : index;
                }
              });
              if (index !== -1) {
                copy[key].splice(index, 1);
              }
            }
          }
          console.log("copy", copy);

          return copy;

          break;
        }
        case "Actions": {
          for (const key in this.properties.actionsProp) {
            if (key === "ble") {
              const valueShowOnPanel = this.properties.actionsProp[key];
              let index = -1;

              copy[key] = [...this.dropDown.Actions[key]];

              copy[key].forEach((e, idx) => {
                const value = e;

                if (key === "ble") {
                  index = value.nickName === valueShowOnPanel ? idx : index;
                }
              });
              if (index !== -1) {
                copy[key].splice(index, 1);
              }
            }
          }
          console.log("copy", copy);

          return copy;

          break;
        }

        default:
          copy = { ...this.dropDown[this.styleClass.firstClass] };
          delete copy[this.styleClass.secondClass];
          break;
      }

      return copy;
    },
    showZoneWidth() {
      let width = 0;
      let longest = 0;
      const imgOnlyWidth = 32;

      function textCaseCount(str) {
        const arr = Array.from(str);
        let val = 0;
        arr.forEach(e => {
          if (e == e.toUpperCase()) {
            val += 1;
          } else {
            val += 0.8;
          }
        });
        return val;
      }

      switch (this.styleClass.firstClass) {
        case "Logic":
          for (const key in this.dropDown.Logic) {
            const val = textCaseCount(this.dropDown.Logic[key]);
            longest = val > longest ? val : longest;
          }
          width = longest * this.unitWidth;

          break;
        case "Arithmetic":
          width = 1.5 * this.unitWidth;
          break;

        case "Comparison":
          width = 1.5 * this.unitWidth;
          break;
        case "Boolean":
          for (const key in this.dropDown.Boolean) {
            const val = textCaseCount(this.dropDown.Boolean[key]);

            longest = val > longest ? val : longest;
          }

          width = longest * this.unitWidth;
          break;
        case "Constant":
          longest = this.properties.value.toString().length;
          width = longest * this.unitWidth;
          break;
        case "Counter":
          width = 70;
          break;
        case "Random":
          width = imgOnlyWidth;
          break;
        case "Timer":
          width = imgOnlyWidth;
          break;
        case "Terminal":
          width = imgOnlyWidth;
          break;
        case "Gadgets":
          for (const key in this.dropDown.Gadgets[this.styleClass.secondClass]) {
            if (
              this.dropDown.Gadgets[this.styleClass.secondClass].hasOwnProperty(key) &&
              key !== "ble"
            ) {
              this.dropDown.Gadgets[this.styleClass.secondClass][key].forEach(e => {
                const val = textCaseCount(String(e));

                longest = val > longest ? val : longest;
              });
            }
          }

          width = longest * this.unitWidth;
          console.log("Gadgets width", width);
          break;

        case "Actions":
          for (const key in this.dropDown.Actions) {
            if (this.dropDown.Actions.hasOwnProperty(key) && key !== "ble") {
              this.dropDown.Actions[key].forEach(e => {
                longest = String(e).length > longest ? String(e).length : longest;
              });
            }
          }

          width = longest * this.unitWidth;
          console.log("Actions width", width);
          break;
        default:
          break;
      }
      return width;
    },
    showZoneGadgetsWidth() {
      let width = 0;
      let longest = 0;

      for (const key in this.dropDown.Gadgets[this.styleClass.secondClass]) {
        this.dropDown.Gadgets[this.styleClass.secondClass][key].forEach(e => {
          const val = textCaseCount(e);
          longest = val > longest ? val : longest;
        });
      }

      const typeWidth = textCaseCount(this.properties.gadgetsProp.type);

      longest = longest > typeWidth ? longest : typeWidth;
      console.log("gadgets longest", longest);
      width = longest * this.unitWidth;
      return {
        width: `${width}px`
      };

      function textCaseCount(str) {
        const arr = Array.from(str);
        let val = 0;
        arr.forEach(e => {
          if (e == e.toUpperCase()) {
            val += 1;
          } else {
            val += 0.8;
          }
        });
        return val;
      }
    },

    showZoneGadgetsTopWidth() {
      let { width: widthVal } = this.showZoneGadgetsWidth;
      widthVal = widthVal.substring(0, widthVal.length - 2);

      console.log("widthVal", widthVal);
      return {
        width: `${Number(widthVal) + 28}px`
      };
    },

    showZoneAIWidth() {
      let width = 0;
      let longest = 0;
      const arrNames = this.properties.aiProps.map(e => e.name);

      arrNames.forEach(e => {
        const val = textCaseCount(e);
        longest = val > longest ? val : longest;
      });
      const typeWidth = textCaseCount(this.label);

      longest = longest > typeWidth ? longest : typeWidth;

      width = longest * this.unitWidth;

      return {
        width: `${width}px`
      };

      function textCaseCount(str) {
        const arr = Array.from(str);
        let val = 0;
        arr.forEach(e => {
          if (e == e.toUpperCase()) {
            val += 1;
          } else {
            val += 0.8;
          }
        });
        return val;
      }
    },
    showZoneAITopWidth() {
      let { width: widthVal } = this.showZoneAIWidth;
      widthVal = widthVal.substring(0, widthVal.length - 2);
      return {
        width: `${Number(widthVal) + 28}px`
      };
    },

    showZoneActionsWidth() {
      let width = 0;
      let longest = 0;
      this.dropDown.Actions.ble.forEach(e => {
        const val = textCaseCount(e);
        longest = val > longest ? val : longest;
      });

      const typeWidth = textCaseCount(this.properties.actionsProp.name);

      longest = longest > typeWidth ? longest : typeWidth;
      console.log("longest", longest);

      width = longest * this.unitWidth;

      return {
        width: `${width + 40}px`
      };

      function textCaseCount(str) {
        const arr = Array.from(str);
        let val = 0;
        arr.forEach(e => {
          if (e == e.toUpperCase()) {
            val += 1;
          } else {
            val += 0.8;
          }
        });
        return val;
      }
    },

    showZoneActionsTopWidth() {
      let { width: widthVal } = this.showZoneActionsWidth;
      widthVal = widthVal.substring(0, widthVal.length - 2);
      return {
        width: `${Number(widthVal) + 28}px`
      };
    },

    // showZoneExpandHeight() {
    //   let height = 0;
    //   let unitHeight = 30;
    //   switch (this.styleClass.firstClass) {
    //     case "Logic":
    //       height = Object.keys(this.nodeLeftList).length * unitHeight;
    //       break;
    //     case "Arithmetic":
    //       height = Object.keys(this.nodeLeftList).length * unitHeight;
    //       break;
    //     case "Comparison":
    //       height = Object.keys(this.nodeLeftList).length * unitHeight;
    //       break;
    //     case "Boolean":
    //       height = Object.keys(this.nodeLeftList).length * unitHeight;
    //       break;
    //     case "Gadgets":
    //       height = Object.keys(this.nodeLeftList).length * unitHeight;
    //       break;

    //     default:
    //       break;
    //   }
    //   return height;
    // },
    selectOperatorSymbol() {
      let symbol = "";
      switch (this.styleClass.firstClass) {
        case "Logic":
          symbol = this.dropDown.Logic[this.styleClass.secondClass];
          break;
        case "Arithmetic":
          symbol = this.dropDown.Arithmetic[this.styleClass.secondClass];
          break;
        case "Comparison":
          symbol = this.dropDown.Comparison[this.styleClass.secondClass];
          break;
        case "Boolean":
          symbol = this.dropDown.Boolean[this.styleClass.secondClass];
          break;
        default:
          break;
      }
      return symbol;
    },
    showZoneStyle() {
      // width: `${this.showZoneWidth - this.baseWidth}px`
      return {
        width: `${this.showZoneWidth}px`
      };
    },
    expandZoneStyle() {
      return {
        width: `${this.showZoneWidth}px`,
        // height: `${this.showZoneExpandHeight}px`,
        paddingRight: "18px",
        paddingLeft: "10px",
        textAlign: "center"
      };
    },
    showZoneInputStyle() {
      return {
        boxSizing: "content-box",
        minWidth: "39px",
        width: `${this.showZoneWidth}px`,
        "padding-left": `${this.styleClass.firstClass === "Constant" ? 6.5 : 0}px`,
        "padding-right": `${this.styleClass.firstClass === "Counter" ? 4 : 6.5}px`,
        "text-align": `${this.styleClass.firstClass === "Counter" ? "right" : "center"}`
      };
    },
    expandZoneTop() {
      // let arr, index;
      // if (this.styleClass.firstClass === "Gadgets") {
      //   arr = Object.keys(this.dropDown.Gadgets[this.styleClass.secondClass]);
      //   // console.log("arr", arr);
      //   index = arr.findIndex(e => {
      //     return e === this.gadgetsTargetName;
      //   });
      //   // console.log("expandZoneTop index", index);
      // } else if (this.styleClass.firstClass === "Actions") {
      //   arr = Object.keys(this.dropDown.Actions);
      //   // console.log("arr", arr);
      //   index = arr.findIndex(e => {
      //     return e === this.actionsTargetName;
      //   });
      //   // console.log("expandZoneTop index", index);
      // }

      return {
        top: `${25}px`,
        left: "-1px"
      };
    }
  },
  watch: {
    //! 藍芽斷線 或新增時 需要 改properties ble的值
    //! 消失時 清空   連線時 加入
    connectedDevicesWithNickname: {
      handler(val, oldVal) {
        console.log(val, oldVal);
        this.register();
        if (this.styleClass.firstClass === "Gadgets") {
          const key = this.styleClass.secondClass;

          // 找所有下拉的資料 確認還有沒有顯示中的那個 如果沒有 指向空的
          const indexOfExist = this.dropDown.Gadgets[key].ble.findIndex(
            e => e.mac === this.properties.gadgetsProp.ble.mac
          );

          if (indexOfExist === -1) {
            this.properties.gadgetsProp.ble = {};
          }
        } else if (this.styleClass.firstClass === "Actions") {
          const indexOfExist = this.dropDown.Actions.ble.findIndex(
            e => e.mac === this.properties.actionsProp.ble.mac
          );

          if (indexOfExist === -1) {
            this.properties.actionsProp.ble = {};
          }
        }
      }
    },

    "properties.inputCount": function(val, oldVal) {
      const { length } = Object.keys(this.properties.inputs);

      if (val > length) {
        for (let i = length + 1; i <= val; i++) {
          this.properties.inputs[`input${i}`] = 0;
        }
      } else {
        for (let i = length; i > val; i--) {
          delete this.properties.inputs[`input${i}`];
        }
      }
      this.$emit("changeInputCount", val, oldVal);
    },
    "properties.value": function(val, oldVal) {
      if (val > this.maxIntNumber) {
        this.properties.value = this.maxIntNumber;
      } else if (val < this.minIntNumber) {
        this.properties.value = this.minIntNumber;
      }
    },

    nodeStyle: {
      handler(newVal, oldVal) {
        // console.log("watch nodeStyle");
        const ptNumber = Number(newVal.paddingTop.substring(0, newVal.paddingTop.length - 2));
        const pbNumber = Number(newVal.paddingBottom.substring(0, newVal.paddingTop.length - 2));

        this.$nextTick(function() {
          const domWidth = this.$refs[`node${this.id}`].clientWidth;
          const domHeight = this.$refs[`node${this.id}`].clientHeight;

          const n = this.properties.inputCount;

          const exactX = Number(newVal.left.substring(0, newVal.left.length - 2));
          const exactY = Number(newVal.top.substring(0, newVal.top.length - 2));
          // input port
          // !Gadgets 類型 打開 顯示項目 未能trigger nodestyle 所以 線不會動 待修改!!
          if (n === 1) {
            if (
              this.styleClass.firstClass === "Gadgets" ||
              this.styleClass.firstClass === "AIModels" ||
              this.styleClass.firstClass === "Actions"
            ) {
              this.portStyle.input[0] = [exactX, exactY + 20.5];
            } else {
              this.portStyle.input[0] = [exactX, exactY + domHeight / 2];
            }
          } else {
            const tempArr = [];
            for (let i = 0; i < n; i++) {
              const temp = [0, 0];
              tempArr.push(temp);
            }
            this.portStyle.input = tempArr;

            this.portStyle.input.forEach((e, index) => {
              this.portStyle.input[index][0] = exactX;
              this.portStyle.input[index][1] =
                exactY + 10 + index * (14 + (domHeight - 6 - 14 * n) / (n - 1));
            });
          }

          if (
            this.styleClass.firstClass === "Gadgets" ||
            this.styleClass.firstClass === "Actions"
          ) {
            this.portStyle.output[0] = [exactX + domWidth, exactY + 20.5];
          } else if (this.styleClass.firstClass === "AIModels") {
            this.portStyle.output.forEach((el, index) => {
              // console.log(this.portOutputStyle[index]["top"]);
              this.portStyle.output[index] = [
                exactX + domWidth,
                exactY +
                  Number(
                    this.portOutputStyle[index].top.substring(
                      0,
                      this.portOutputStyle[index].top.length - 2
                    )
                  )
              ];
            });
            // console.log(this.portOutputStyle);
            // console.log("change link style AI");

            // console.log(this.portStyle.output);
          } else {
            this.portStyle.output[0] = [exactX + domWidth, exactY + domHeight / 2];
          }
          this.$emit("calcLines");
        });
      },
      immediate: true
    },

    dropDownTicktok: {
      handler(val, oldVal) {
        console.log("dropDownTicktok", val);
        if (val !== this.id) {
          this.showDropDown = false;
          this.showExpandZoneGadgets = false;
          this.showExpandZoneActions = false;
        }
      }
    }
  },
  methods: {
    copyNode(id){
      this.$emit("copyNode", id)
    },
    deleteNode(id){
      this.$emit("deleteNode", id)
    },
    register() {
      //! Gadgets 有用到個別機器 要到此處註冊
      this.dropDown.Gadgets.Infrared.ble = this.connectedDevicesWithNickname;
      this.dropDown.Gadgets.Ultrasound.ble = this.connectedDevicesWithNickname;
      this.dropDown.Gadgets.LightSensor.ble = this.connectedDevicesWithNickname;
      this.dropDown.Gadgets.MicroSwitch.ble = this.connectedDevicesWithNickname;
      this.dropDown.Gadgets.SoilMoisture.ble = this.connectedDevicesWithNickname;
      this.dropDown.Gadgets.HallSensor.ble = this.connectedDevicesWithNickname;
      this.dropDown.Gadgets.VariableBoard.ble = this.connectedDevicesWithNickname;
      this.dropDown.Gadgets.JoystickButton.ble = this.connectedDevicesWithNickname;
      this.dropDown.Gadgets.JoystickAnalog.ble = this.connectedDevicesWithNickname;

      this.dropDown.Actions.ble = this.connectedDevicesWithNickname;
    },
    clickAIEyeIcon() {
      if (!this.isDragging) {
        this.ticktok2++;
        this.showConfidence = !this.showConfidence;
        this.$emit("calcLines");
      }
    },
    clickSettingIcon() {
      if (!this.isDragging) {
        this.showExpandZoneGadgets = false;
        this.showZoneGadgets = !this.showZoneGadgets;

        this.showZoneActions = !this.showZoneActions;
        this.$emit("calcLines");
      }
    },
    clickEyeIcon() {
      if (!this.isDragging) {
        this.showMoreZoneGadgets = !this.showMoreZoneGadgets;
      }
    },
    setActionsTargetName(name) {
      if (!this.isDragging) {
        if (name === this.actionsTargetName) {
          this.showExpandZoneActions = !this.showExpandZoneActions;
        } else if (this.showExpandZoneActions === false) {
          this.showExpandZoneActions = true;
        }
        this.actionsTargetName = name;
      }
    },
    selectActionsProp(item) {
      this.properties.actionsProp[this.actionsTargetName] = item;

      if (this.actionsTargetName === "ble") {
        const index = this.connectedDevicesWithNickname.findIndex(
          e => this.properties.actionsProp.ble.nickName === e.nickName
        );

        this.properties.actionsProp.ble.mac = this.connectedDevicesWithNickname[index].mac;
      }

      this.showExpandZoneActions = false;
    },

    setGadgetsTargetName(name) {
      if (!this.isDragging) {
        if (name === this.gadgetsTargetName) {
          this.showExpandZoneGadgets = !this.showExpandZoneGadgets;
        } else if (this.showExpandZoneGadgets === false) {
          this.showExpandZoneGadgets = true;
        }
        this.gadgetsTargetName = name;
      }
    },
    selectGadgetsProp(item) {
      this.properties.gadgetsProp[this.gadgetsTargetName] = item;

      if (this.gadgetsTargetName === "ble") {
        const index = this.connectedDevicesWithNickname.findIndex(
          e => this.properties.gadgetsProp.ble.nickName === e.nickName
        );
        // console.log("bluetoothTargets", this.bluetoothTargets);
        // console.log("index", index);
        this.properties.gadgetsProp.ble.mac = this.connectedDevicesWithNickname[index].mac;
      }

      this.showExpandZoneGadgets = false;
    },
    selectOperator(key) {
      // emit到上層 或是 直接改 props
      this.styleClass.secondClass = key;
      //! 暫時 直接用secondClass 來 代表 compareType
      this.properties.compareType = key;
      this.$emit("changeOperator", this.id);
    },
    selectOptionMouseDown(e) {
      this.isDragging = false;
      const x = e.pageX;
      const y = e.pageY;
      this.nowX = x;
      this.nowY = y;
      // console.log(x, y);
    },
    selectOptionMouseUp(e) {
      const x = e.clientX;
      const y = e.clientY;

      if (this.nowX !== x || this.nowY !== y) {
        this.isDragging = true;
      }
    },
    selectOptionClick() {
      if (!this.isDragging) {
        this.showDropDown = !this.showDropDown;
      }
    },
    handleMousedown(e) {
      const target = e.target || e.srcElement;
      // console.log(target);
      if (
        target.className.indexOf("node-input") < 0 &&
        target.className.indexOf("node-output") < 0
      ) {
        this.$emit("closeDropDown", this.id);
        this.$emit("nodeSelected", e);
      }

      this.selectOptionMouseDown(e);
    },
    handleMouseup(e) {
      this.selectOptionMouseUp(e);
    },
    // handleMouseOver() {
    //   this.show.delete = true;
    // },
    // handleMouseLeave() {
    //   this.show.delete = false;
    // },
    outputMouseDown(e, index) {
      this.$emit("linkingStart", index);
      e.stopPropagation();
      e.preventDefault();
    },
    inputMouseDown(e) {
      e.preventDefault();
    },
    inputMouseUp(e, index, portCount) {
      this.$emit("linkingStop", index, portCount);
      e.preventDefault();
    },
    handleDbClick() {
      // console.log("this.showDropDown", this.showDropDown);
      // console.log("this.showExpandZoneGadgets", this.showExpandZoneGadgets);
      if (
        this.styleClass.firstClass === "Boolean" ||
        this.styleClass.firstClass === "Constant" ||
        this.styleClass.firstClass === "Random" ||
        this.styleClass.firstClass === "Timer" ||
        this.styleClass.firstClass === "Terminal" ||
        this.styleClass.firstClass === "Gadgets" ||
        this.styleClass.firstClass === "AIModels" ||
        this.styleClass.firstClass === "Actions"
      ) {
        return;
      }
      this.$emit("nodeDbClick", this.id);
    },
    dontSelect(e) {
      // this.$refs.dontSelectInput.setSelectionRange(0, 0);
      // this.$refs.dontSelectInput.selectionStart = this.$refs.dontSelectInput.selectionEnd;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$themeColor: rgb(255, 136, 85);
$portSize: 12;
$portRadius: 7;
$portRadiusSmall: 4;
$portRadiusBig: 12;
$green: #91d96c;
$blue: #6eb6d6;
$black: #282828;
$light-black: #727374;
$gray: #9b9c9e;
.setting-icon,
.eye-icon {
  position: relative;
  display: inline-block;
  height: 17px;
  width: 17px;
  border-radius: 3px;
  cursor: pointer;
  img {
    max-width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.setting-icon {
  background-color: #4b4c4d;
}
.eye-icon {
  margin-left: 5px;
}

.flowchart-node {
  &.gadgets {
    background-color: $blue;

    .gadgets-top {
      box-sizing: content-box;
      display: flex;
      font-size: 15px;
      justify-content: space-between;
      align-items: center;
      color: white;
      height: 21px;
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
      .img-wrapper {
        display: flex;
        align-items: center;
      }
      span {
        font-size: 15px;

        display: inline-block;
        max-width: 100px;
        overflow: hidden;
      }
    }
    .node-container {
      position: relative;
      cursor: default;
      .show-zone-gadgets {
        font-size: 13px;
        cursor: default;
        //for 紅外線 其他組可能會換寬度
        position: relative;
        height: 25px;
        line-height: 25px;
        background-color: white;
        border: 1px solid $light-black;
        border-top: 0;
        padding-left: 10px;
        padding-right: 18px;
        box-sizing: content-box;

        &.open-style {
          border-bottom: 1px solid transparent !important;
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        & > span {
          overflow: hidden;
          // width: 60%;
        }

        &.first {
          margin-top: 4px;
          border-top: 1px solid $light-black;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
        }
        //因為vue listrender不能 找出last-of-type
        &.last {
          border-bottom: 1px solid $light-black;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
        }
        .arrow {
          position: absolute;
          top: 50%;
          right: 5px;
          transform: translateY(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid $black;
          z-index: 99;
        }
      }

      .expand-zone-gadgets {
        //for 紅外線 其他組可能會換寬度
        border: 1px solid $light-black;
        position: absolute;
        z-index: 100;
        cursor: pointer;
        background-color: white;
        border-top: 0;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.16);

        .custom-option {
          cursor: pointer;
          height: 25px;
          line-height: 25px;
          padding-left: 10px;
          padding-right: 18px;
          box-sizing: content-box;
          &:hover {
            background-color: $blue;
            color: white;
          }
        }
      }

      .more-gadgets {
        cursor: default;
        font-size: 13px;
        margin-top: 5px;
        position: relative;
        height: 25px;
        line-height: 25px;
        background-color: white;
        border: 1px solid $light-black;
        border-radius: 5px;
        padding-left: 10px;
        padding-right: 10px;
        text-align: end;
      }
    }
    .node-port {
      background-color: $blue;
      &:hover {
        .node-port-small {
          background-color: $blue;
        }
      }
    }
    .node-port-small {
    }
  }

  &.ai {
    background-color: $black;

    color: white;
    border-radius: 10px;
    .node-port {
      background-color: $black;
      &:hover {
        .node-port-small {
          background-color: $black;
        }
      }
    }
    .node-port-small {
    }
  }

  &.actions {
    background-color: $gray;

    .actions-top {
      display: flex;
      font-size: 15px;
      justify-content: space-between;
      align-items: center;
      color: white;
      height: 21px;
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
      box-sizing: content-box;
      .img-wrapper {
        display: flex;
        align-items: center;
      }
      span {
        display: inline-block;
        overflow: hidden;
      }
    }
    .node-container {
      position: relative;
      cursor: default;
      .show-zone-actions {
        cursor: default;
        position: relative;
        height: 25px;
        line-height: 25px;
        background-color: white;
        border: 1px solid $light-black;
        border-top: 0;
        box-sizing: content-box;
        padding-left: 10px;
        padding-right: 18px;

        & > span {
          overflow: hidden;
          // width: 60%;
        }

        &.open-style {
          border-bottom: 1px solid transparent !important;
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &.first {
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;

          margin-top: 4px;
          border-top: 1px solid $light-black;
        }
        //因為vue listrender不能 找出last-of-type
        &.last {
          border-bottom: 1px solid $light-black;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
        }
        .arrow {
          position: absolute;
          top: 50%;
          right: 8px;
          transform: translate(50%, -50%);
          width: 0;
          height: 0;
          border-right: 6.4px solid transparent;
          border-left: 6.4px solid transparent;

          border-top: 8px solid $black;

          z-index: 99;
        }
      }
      .expand-zone-actions {
        border: 1px solid $light-black;
        border-top: 0;
        position: absolute;
        z-index: 100;
        cursor: pointer;
        background-color: white;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.16);
        overflow: hidden;
        .custom-option {
          cursor: pointer;
          height: 25px;
          line-height: 25px;
          padding-left: 10px;
          padding-right: 18px;
          box-sizing: content-box;
          &:hover {
            background-color: $gray;
            color: white;
          }
        }
      }
    }
    .node-port {
      background-color: $gray;
      &:hover {
        .node-port-small {
          background-color: $gray;
        }
      }
    }
    .node-port-small {
    }
  }
  margin: 0;
  // height: 43px;
  position: absolute;
  box-sizing: border-box;
  border: none;
  background-color: $green;

  z-index: 1;
  // cursor: move;
  transform-origin: top left;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
  font-family: Arial;
  font-size: 18px;
  font-weight: normal;
  color: #282828;

  .node-container {
    .show-zone {
      cursor: default;
      padding-left: 10px;
      padding-right: 18px;
      position: relative;
      height: 30px;
      line-height: 30px;
      background-color: white;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      &.round {
        border-radius: 5px;
      }
      .arrow {
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translate(50%, -50%);
        width: 0;
        height: 0;

        border-right: 6.4px solid transparent;
        border-left: 6.4px solid transparent;

        border-top: 8px solid $green;

        z-index: 99;
      }
    }
    .expand-zone {
      position: absolute;
      background-color: white;
      border: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.16);
      .custom-option {
        cursor: pointer;
        padding-left: 10px;
        text-align: start;
        height: 30px;
        line-height: 30px;
        box-sizing: content-box;

        &:hover {
          background-color: $green;
          color: white;
        }
      }
    }

    .show-zone-input {
      position: relative;
      .counter-up {
        opacity: 0.5;

        &.open {
          opacity: 1;
        }
        position: absolute;
        top: -13px;
        left: 50%;
        transform: translateX(-50%);
        border-bottom: solid 8px white;
        border-left: solid 5px transparent;
        border-right: solid 5px transparent;
      }
      .counter-down {
        opacity: 0.5;
        &.open {
          opacity: 1;
        }
        position: absolute;
        bottom: -13px;
        left: 50%;
        transform: translateX(-50%);
        border-top: solid 8px white;
        border-left: solid 5px transparent;
        border-right: solid 5px transparent;
      }
      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input {
        border-radius: 5px;
        border: 0;
        padding-top: 0;
        padding-bottom: 0;
        height: 30px;
        line-height: 30px;
        &[type="number"][disabled] {
          background-color: white;
        }
        &:focus {
          outline: none;
        }
      }
    }
    .img-only-box {
      cursor: default;

      img {
        height: 32px;
      }
    }

    .ai-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: content-box;
      .text {
        margin-right: 15px;
        height: 21px;
        line-height: 21px;
        box-sizing: content-box;
      }
      img {
        cursor: pointer;
        width: 17px;
        height: 17px;
      }
    }
    .ai-hr {
      margin-top: 4.5px;
      margin-bottom: 4.5px;
      border: 1px solid white;
    }
    .ai-confidence {
      text-align: left;
      margin-bottom: 10px;
      &.last {
        margin-bottom: 0;
      }
      .name {
        font-size: 15px;
      }
      .value {
        color: #c6c8cb;

        text-align: end;
        font-size: 13px;
        border-radius: 5px;
        border: 0;
        background-color: #4b4c4d;
        // padding-right: 5px;
        margin-top: 5px;
        height: 25px;
        line-height: 25px;
      }
    }
  }

  .node-port {
    cursor: auto;
    position: absolute;
    height: #{$portRadius * 2}px;
    width: #{$portRadius}px;
    transform: translateY(-50%);
    background: $green;

    .val-zone {
      white-space: nowrap;
      position: absolute;
      height: 12px;
      border-radius: 2px;
      border: solid 0.5px #9b9c9e;
      background-color: #f3f5f9;
      font-size: 11px;
      line-height: 12px;
      box-sizing: content-box;
      top: 50%;
      transform: translateY(-50%);
      color: black;
      padding-left: 3px;
      padding-right: 3px;
      padding-top: 1px;
      padding-bottom: 1px;
      opacity: 0.5;

      &.input {
        right: 7px;
      }
      &.output {
        left: 7px;
      }
    }
  }
  .node-port-big {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    // background: #ffe2bc80;
    height: #{$portRadiusBig * 2}px;
    width: #{$portRadiusBig}px;
    &.input {
      right: #{-$portRadiusBig}px;
      border-bottom-left-radius: #{$portRadiusBig * 2}px;
      border-top-left-radius: #{$portRadiusBig * 2}px;
      width: #{$portRadiusBig * 2}px;
    }
    &.output {
      // left: 0;
      left: #{-$portRadiusBig}px;
      width: #{$portRadiusBig * 2}px;

      border-bottom-right-radius: #{$portRadiusBig * 2}px;
      border-top-right-radius: #{$portRadiusBig * 2}px;
    }
  }
  .node-port-small {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: white;
    height: #{$portRadiusSmall * 2}px;
    width: #{$portRadiusSmall}px;
    &:hover {
      background-color: $green;
    }
    &.input {
      right: 0;
      border-bottom-left-radius: #{$portRadiusSmall * 2}px;
      border-top-left-radius: #{$portRadiusSmall * 2}px;
    }
    &.output {
      left: 0;
      border-bottom-right-radius: #{$portRadiusSmall * 2}px;
      border-top-right-radius: #{$portRadiusSmall * 2}px;
    }
  }
  .node-input {
    left: #{-4 + $portRadius/- 2 +1}px;
    border-bottom-left-radius: #{$portRadius * 2}px;
    border-top-left-radius: #{$portRadius * 2}px;
  }
  .node-output {
    //+1 =>因為原本有奇怪的沒密合
    right: #{-4 + $portRadius/- 2 +1}px;
    border-bottom-right-radius: #{$portRadius * 2}px;
    border-top-right-radius: #{$portRadius * 2}px;
  }
  .toolTips {
    &[data-tooltip]:before {
      /* needed - do not touch */
      content: attr(data-tooltip);
      position: absolute;
      display:none;

      padding: 5px;
      color: #333;
      background: yellow;
      font-size: 12px;
    }
    &[data-tooltip]:hover:before {
      display:block;
      z-index:100;
    }
  }
  .left{
    &[data-tooltip]:hover:before {
      margin-left: -80px;
    }
  }
  .right{
    &[data-tooltip]:hover:before {
      margin-left:20px;
    }
  }
  .nodeOption {
    position: absolute;
    right: 0px;
    top: -18px;
    height: 18px;
    display: flex;
    flex-direction: row;
    div {
      border-radius: 5px 5px 0 0 ;
      background-color: #9b9c9e;
      color: #727374;
      width: 22px;
      cursor: pointer;
      height: 18px;
      display:flex;
      img{
        height:10px;
        width: 10px;
        margin: auto;
      }
      &:hover {
        background-color: #4b4c4d;
      }
    }
  }
}
.selected {
  z-index: 998;
  border: 2px solid rgb(253, 172, 66);
  border-radius: 5px;
  .show-zone-actions,
  .show-zone-input,
  .show-zone,
  .show-zone-gadgets {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2);
  }
}
</style>
